import PropTypes from "prop-types"
import React from "react"
import { useMarina } from "src/contexts/MarinaContext"

import { formatCurrencyFromMinorUnits } from "src/utils/UnitConversion"

const BillingSummaryStats = ({ summary }) => {
  const { presentmentCurrency } = useMarina()

  if (!summary) return null

  const money = (amount) =>
    formatCurrencyFromMinorUnits({ amount, currency: presentmentCurrency })

  const stats = [
    { label: "Invoiced", value: money(summary.invoiced) },
    {
      label: "Refunded",
      value: money(summary.refunded),
      valueClass: "text-red-600",
    },
    { label: "Net", value: money(summary.net) },
    {
      label: "Outstanding",
      value: money(summary.outstanding),
      valueClass: "text-orange-600",
    },
  ]

  return (
    <div className="mb-4 flex flex-wrap gap-x-10 gap-y-3 border-t pt-4">
      {stats.map(({ label, value, valueClass }) => (
        <div key={label} className="flex flex-col">
          <span className="text-xs font-semibold uppercase tracking-wide text-gray-500">
            {label}
          </span>
          <span className={`font-semibold ${valueClass || "text-gray-900"}`}>
            {value}
          </span>
        </div>
      ))}
    </div>
  )
}

BillingSummaryStats.propTypes = {
  summary: PropTypes.shape({
    invoiced: PropTypes.number,
    refunded: PropTypes.number,
    net: PropTypes.number,
    outstanding: PropTypes.number,
  }),
}

export default BillingSummaryStats
